import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '@app/core/shared/auth.service';
import { TelegramService } from '@shared/services/telegram.service';
import { retrieveRawInitData } from '@tma.js/sdk';
import { map, of, switchMap } from 'rxjs';

export const getMeGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const telegramService = inject(TelegramService);
  let rawInitData;

  try {
    rawInitData = retrieveRawInitData();
  } catch (error) {}

  return (rawInitData ? telegramService.signIn({ raw_init_data: rawInitData }) : of(null))
    .pipe(
      switchMap(() => authService.me()),
      map(() => true),
    );
};


